/**
 * E-spdp(www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, February 2024
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import _, { cloneDeep } from 'lodash';

import { DecisionContainer } from '../../containers';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import fetch from '../../core/fetch/fetch.server';
import history from '../../core/history';
import ModalAlert from './ModalAlert';
import { PersonalDataContainer } from '../../containers';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import { runService } from '../../actions/eservices';
import utils from './utils';
import v from './validators';

import pans from './panStyle.scss';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const sewageNetworkOptions = [
  {
    label: 'TAK',
    value: true,
    state: 'sewageNetwork',
  },
  {
    label: 'NIE',
    value: false,
    state: 'sewageNetwork',
  },
];

const contractSignedOptions = [
  {
    label: 'TAK',
    value: true,
    state: 'contractSigned',
  },
  {
    label: 'NIE',
    value: false,
    state: 'contractSigned',
  },
];

const treatmentPlantContractSignedOptions = [
  {
    label: 'TAK',
    value: true,
    state: 'treatmentPlantContractSigned',
  },
  {
    label: 'NIE',
    value: false,
    state: 'treatmentPlantContractSigned',
  },
]

const contractFrequencyOptions = [
  {
    label: 'raz na tydzień',
    value: 'tydzien',
    state: 'contractFrequency',
  },
  {
    label: 'raz na miesiąc',
    value: 'miesiac',
    state: 'contractFrequency',
  },
  {
    label: 'raz na kwartał',
    value: 'kwartal',
    state: 'contractFrequency',
  },
  {
    label: 'raz na rok',
    value: 'rok',
    state: 'contractFrequency',
  },
  {
    label: 'inna',
    value: 'inna',
    state: 'contractFrequency',
  },
];

const treatmentPlantContractFrequencyOptions = [
  {
    label: 'raz na kwartał',
    value: 'kwartal',
    state: 'treatmentPlantContractFrequency',
  },
  {
    label: 'raz na rok',
    value: 'rok',
    state: 'treatmentPlantContractFrequency',
  },
  {
    label: 'raz na 2 lata',
    value: '2lata',
    state: 'treatmentPlantContractFrequency',
  },
  {
    label: 'inna',
    value: 'inna',
    state: 'treatmentPlantContractFrequency',
  },
];

const typeOptions = [
  {
    label: 'zbiornika bezodpływowego',
    value: 'zbiornik',
    state: 'type',
  },
  {
    label: 'przydomowej oczyszczalni ścieków',
    value: 'oczyszczalnia',
    state: 'type',
  },
];

const constructionTypeOptions = [
  {
    label: 'zbiornik jednokomorowy',
    value: 'jednokomorowy',
    state: 'constructionType',
  },
  {
    label: 'zbiornik dwukomorowy',
    value: 'dwukomorowy',
    state: 'constructionType',
  },
  {
    label: 'zbiornik trzykomorowy',
    value: 'trzykomorowy',
    state: 'constructionType',
  },
];

const technologyTypeOptions = [
  {
    label: 'kręgi betonowe',
    value: 'betonowy',
    state: 'technologyType',
  },
  {
    label: 'metalowy',
    value: 'metalowy',
    state: 'technologyType',
  },
  {
    label: 'poliestrowy',
    value: 'poliestrowy',
    state: 'technologyType',
  },
  {
    label: 'zalewane betonem',
    value: 'zalewany',
    state: 'technologyType',
  },
  {
    label: 'inne',
    value: 'inne',
    state: 'technologyType',
  },
];

const bottomSealantTypeOptions = [
  {
    label: 'beton',
    value: 'beton',
    state: 'bottomSealantType',
  },
  {
    label: 'materiał ceramiczny',
    value: 'ceramiczny',
    state: 'bottomSealantType',
  },
  {
    label: 'brak uszczelnienia',
    value: 'brak',
    state: 'bottomSealantType',
  },
  {
    label: 'inne',
    value: 'inne',
    state: 'bottomSealantType',
  },
];

const InfoTypeDict = {
  address: {
    label: 'Adres nieruchomości:',
    editable: true,
  },
  peopleCount: {
    label: 'Liczba osób zamieszkujących nieruchomość:',
    editable: true,
  },
  sewageNetwork: {
    label: 'Budynek podłączony do sieci kanalizacyjnej?',
    editable: true,
    type: 'Select',
    options:  sewageNetworkOptions,
  },
};

const InfoTypeDict2 = {
  sewageNetworkConnectionDate: {
    label: 'Data przyłączenia do miejskiej sieci kanalizacyjnej:',
    editable: true,
  },
}

const InfoTypeDict3 = {
  type: {
    label: 'Zgłaszam eksploatację:',
    editable: true,
    type: 'Select',
    options:  typeOptions,
  },
}

let septicTankInfoDict = {
  capacity: {
    label: 'Pojemność [m3]:',
    editable: true,
  },
  installationYear: {
    label: 'Rok uruchomienia:',
    editable: true,
  },
  constructionType: {
    label: 'Konstrukcja zbiornika bezodpływowego:',
    editable: true,
    type: 'Select',
    options:  constructionTypeOptions,
  },
  technologyType: {
    label: 'Technologia wykonania zbiornika:',
    editable: true,
    type: 'Select',
    options:  technologyTypeOptions,
  },
  bottomSealantType: {
    label: 'Uszczelnienie dna zbiornika (rodzaj):',
    editable: true,
    type: 'Select',
    options:  bottomSealantTypeOptions,
  },
  contractSigned: {
    label: 'Czy jest podpisana umowa z firmą na opróżnianie zbiornika?',
    editable: true,
    type: 'Select',
    options:  contractSignedOptions,
  },
}

const treatmentPlantTypeOptions = [
  {
    label: 'mechaniczno-biologiczna z drenażem rozsączającym',
    value: 'typ1',
    state: 'treatmentPlantType',
  },
  {
    label: 'mechaniczno-biologiczna z odprowadzaniem do wód',
    value: 'typ2',
    state: 'treatmentPlantType',
  },
  {
    label: 'mechaniczna(odstojnik) z drenażem rozsączającym',
    value: 'typ3',
    state: 'treatmentPlantType',
  },
  {
    label: 'mechaniczna (odstojnik) z drenażem do wód',
    value: 'typ4',
    state: 'treatmentPlantType',
  },
  {
    label: 'inny',
    value: 'inny',
    state: 'treatmentPlantType',
  },
];

const receiverTypeOptions = [
  {
    label: 'grunt (drenaż rozsączający)',
    value: 'grunt',
    state: 'receiverType',
  },
  {
    label: 'rów melioracyjny',
    value: 'row',
    state: 'receiverType',
  },
  {
    label: 'inny',
    value: 'inny',
    state: 'receiverType',
  },
];

let treatmentPlantInfoDict = {
  output: {
    label: 'Przepustowość [m3/dobę]:',
    editable: true,
  },
  treatmentPlantCapacity: {
    label: 'Pojemność osadnika [m3]:',
    editable: true,
  },
  reportingDate: {
    label: 'Data zgłoszenia do Wydz. Architektury i Budownictwa Starostwa Powiatowego:',
    editable: true,
  },
  treatmentPlantInstallationYear: {
    label: 'Rok uruchomienia:',
    editable: true,
  },
  producer: {
    label: 'Producent:',
    editable: true,
  },
  model: {
    label: 'Model:',
    editable: true,
  },
  treatmentPlantType: {
    label: 'Typ przydomowej oczyszczalni:',
    editable: true,
    type: 'Select',
    options:  treatmentPlantTypeOptions,
  },
  receiverType: {
    label: 'Odbiornik ścieków oczyszczonych:',
    editable: true,
    type: 'Select',
    options:  receiverTypeOptions,
  },
  lastRemovingDate: {
    label: 'Data ostatniego wywozu osadu ściekowego:',
    editable: true,
  },
  treatmentPlantContractSigned: {
    label: 'Czy jest podpisana umowa z firmą na wywóz osadów ściekowych?',
    editable: true,
    type: 'Select',
    options:  treatmentPlantContractSignedOptions,
  },
}

let contractInfoDict = {
  contractDateAndNumber: {
    label: 'Data zawarcia i nr umowy:',
    editable: true,
    type: 'textarea',
    rows: 4,
  },
  contractorNameAndAddress: {
    label: 'Nazwa i adres firmy świadczącej usługę wywozu nieczystości:',
    editable: true,
    type: 'textarea',
    rows: 4,
  },
  contractDates: {
    label: 'Data ostatnich wywozów nieczystości ciekłych obejmujących okres 12 miesięcy (proszę dołączyć posiadane dowody opłat za usługę wywozu nieczystości ciekłych):',
    editable: true,
    type: 'textarea',
    rows: 10,
  },
  contractFrequency: {
    label: 'Częstotliwość opróżniania zbiornika:',
    editable: true,
    type: 'Select',
    options:  contractFrequencyOptions,
  },
  contractFrequencyAmount: {
    label: 'Ilość wywożonego osadu [m3]:',
    editable: true,
  },
}

let treatmentPlantContractInfoDict = {
  treatmentPlantContractDateAndNumber: {
    label: 'Data zawarcia i nr umowy:',
    editable: true,
    type: 'textarea',
    rows: 4,
  },
  treatmentPlantContractorNameAndAddress: {
    label: 'Nazwa i adres firmy świadczącej usługę wywozu nieczystości:',
    editable: true,
    type: 'textarea',
    rows: 4,
  },
  treatmentPlantContractFrequency: {
    label: 'Częstotliwość opróżniania:',
    editable: true,
    type: 'Select',
    options:  treatmentPlantContractFrequencyOptions,
  },
  treatmentPlantContractFrequencyAmount: {
    label: 'Ilość wywożonego osadu [m3]:',
    editable: true,
  },
}

class ZgloszenieOczyszczalni extends React.Component {
  state = {
    info: {
      address: null,
      peopleCount: null,
      sewageNetwork: null,
      sewageNetworkConnectionDate: null,
      type: null,
    },
    septicTankInfo: {
      capacity: null,
      installationYear: null,
      constructionType: null,
      technologyType: null,
      otherTechnologyType: null,
      bottomSealantType: null,
      otherBottomSealantType: null,
      contractSigned: null,
      contractDateAndNumber: null,
      contractorNameAndAddress: null,
      contractDates: null,
      contractFrequency: null,
      otherContractFrequency: null,
      contractFrequencyAmount: null,
    },
    treatmentPlantInfo: {
      output: null,
      treatmentPlantCapacity: null,
      reportingDate: null,
      treatmentPlantInstallationYear: null,
      producer: null,
      model: null,
      treatmentPlantType: null,
      otherTreatmentPlantType: null,
      receiverType: null,
      otherReceiverType: null,
      lastRemovingDate: null,
      treatmentPlantContractSigned: null,
      treatmentPlantContractDateAndNumber: null,
      treatmentPlantContractorNameAndAddress: null,
      treatmentPlantContractFrequency: null,
      treatmentPlantContractOtherFrequency: null,
      treatmentPlantContractFrequencyAmount: null,
    },
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    selectedParcels: [],
  };

  validators = {
    address: [v.NotNull],
    peopleCount: [v.NotNull, v.isNumber],
    sewageNetwork: [v.NotSelected],
    sewageNetworkConnectionDate: [],
    type: [],
    capacity: [],
    installationYear: [],
    constructionType: [],
    technologyType: [],
    otherTechnologyType: [],
    bottomSealantType: [],
    otherBottomSealantType: [],
    contractSigned: [],
    contractDateAndNumber: [],
    contractorNameAndAddress: [],
    contractDates: [],
    contractFrequency: [],
    otherContractFrequency: [],
    contractFrequencyAmount: [],
    output: [],
    treatmentPlantCapacity: [],
    reportingDate: [],
    treatmentPlantInstallationYear: [],
    producer: [],
    model: [],
    treatmentPlantType: [],
    otherTreatmentPlantType: [],
    receiverType: [],
    otherReceiverType: [],
    lastRemovingDate: [],
    treatmentPlantContractSigned: [],
    treatmentPlantContractDateAndNumber: [],
    treatmentPlantContractorNameAndAddress: [],
    treatmentPlantContractFrequency: [],
    treatmentPlantContractOtherFrequency: [],
    treatmentPlantContractFrequencyAmount: [],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        }, () => this.updateValidators());
      });
  }

  updateValidators = () => {
    if (this.state.info.sewageNetwork) {
      this.validators.sewageNetworkConnectionDate = [v.NotNull, v.CheckDate];
      this.validators.type = [];
      this.validators.capacity = [];
      this.validators.installationYear = [];
      this.validators.constructionType = [];
      this.validators.technologyType = [];
      this.validators.otherTechnologyType = [];
      this.validators.bottomSealantType = [];
      this.validators.otherBottomSealantType = [];
      this.validators.contractSigned = [];
    } else {
      this.validators.sewageNetworkConnectionDate = [];
      this.validators.type = [v.NotSelected];

      if (this.state.info.type == 'zbiornik') {
        this.validators.capacity = [v.NotNull, v.isNumber];
        this.validators.installationYear = [v.NotNull, v.isNumber];
        this.validators.constructionType = [v.NotSelected];
        this.validators.technologyType = [v.NotSelected];
        if (this.state.septicTankInfo.technologyType == 'inne') {
          this.validators.otherTechnologyType = [v.NotNull];
        } else {
          this.validators.otherTechnologyType = [];
        }
        
        this.validators.bottomSealantType = [v.NotSelected];
        if (this.state.septicTankInfo.bottomSealantType == 'inne') {
          this.validators.otherBottomSealantType = [v.NotNull];
        } else {
          this.validators.otherBottomSealantType = [];
        }
        this.validators.contractSigned = [v.NotSelected];

        if (this.state.septicTankInfo.contractSigned) {
          this.validators.contractDateAndNumber = [v.NotNull];
          this.validators.contractorNameAndAddress = [v.NotNull];
          this.validators.contractDates = [v.NotNull];
          this.validators.contractFrequency = [v.NotSelected];
          this.validators.contractFrequencyAmount = [v.NotNull, v.isNumber];
          if (this.state.septicTankInfo.contractFrequency == 'inna') {
            this.validators.otherContractFrequency = [v.NotNull];
          } else {
            this.validators.otherContractFrequency = [];
          }
        } else {
          this.validators.contractDateAndNumber = [];
          this.validators.contractorNameAndAddress = [];
          this.validators.contractDates = [];
          this.validators.contractFrequency = [];
          this.validators.otherContractFrequency = [];
          this.validators.contractFrequencyAmount = [];
        }
      } else {
        this.validators.capacity = [];
        this.validators.installationYear = [];
        this.validators.constructionType = [];
        this.validators.technologyType = [];
        this.validators.otherTechnologyType = [];
        this.validators.bottomSealantType = [];
        this.validators.otherBottomSealantType = [];
        this.validators.contractSigned = [];
      }

      if (this.state.info.type == 'oczyszczalnia') {
        this.validators.output = [v.NotNull, v.isNumber];
        this.validators.treatmentPlantCapacity = [v.NotNull, v.isNumber];
        this.validators.reportingDate = [v.NotNull, v.CheckDate];
        this.validators.treatmentPlantInstallationYear = [v.NotNull, v.isNumber];
        this.validators.producer = [v.NotNull];
        this.validators.model = [v.NotNull];
        this.validators.treatmentPlantType = [v.NotSelected];
        if (this.state.treatmentPlantInfo.treatmentPlantType == 'inny') {
          this.validators.otherTreatmentPlantType = [v.NotNull];
        } else {
          this.validators.otherTreatmentPlantType = [];
        }
        this.validators.receiverType = [v.NotSelected];
        if (this.state.treatmentPlantInfo.receiverType == 'inny') {
          this.validators.otherReceiverType = [v.NotNull];
        } else {
          this.validators.otherReceiverType = [];
        }
        this.validators.lastRemovingDate = [v.NotNull, v.CheckDate];
        this.validators.treatmentPlantContractSigned = [v.NotSelected];
        if (this.state.treatmentPlantInfo.treatmentPlantContractSigned) {
          this.validators.treatmentPlantContractDateAndNumber = [v.NotNull];
          this.validators.treatmentPlantContractorNameAndAddress = [v.NotNull];
          this.validators.treatmentPlantContractFrequency = [v.NotSelected];
          this.validators.treatmentPlantContractFrequencyAmount = [v.NotNull, v.isNumber];
          if (this.state.treatmentPlantInfo.treatmentPlantContractFrequency == 'inna') {
            this.validators.treatmentPlantContractOtherFrequency = [v.NotNull];
          } else {
            this.validators.treatmentPlantContractOtherFrequency = [];
          }
        } else {
          this.validators.treatmentPlantContractDateAndNumber = [];
          this.validators.treatmentPlantContractDateAndNumber = [];
          this.validators.treatmentPlantContractorNameAndAddress = [];
          this.validators.treatmentPlantContractFrequency = [];
          this.validators.treatmentPlantContractOtherFrequency = [];
          this.validators.treatmentPlantContractFrequencyAmount = [];
        }
      } else {
        this.validators.output = [];
        this.validators.treatmentPlantCapacity = [];
        this.validators.reportingDate = [];
        this.validators.treatmentPlantInstallationYear = [];
        this.validators.producer = [];
        this.validators.model = [];
        this.validators.treatmentPlantType = [];
        this.validators.otherTreatmentPlantType = [];
        this.validators.receiverType = [];
        this.validators.otherReceiverType = [];
        this.validators.lastRemovingDate = [];
        this.validators.treatmentPlantContractSigned = [];
      }
    }
  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;

    if (name == 'type') {
      this.setState(
        {
          [group]: {
            ...this.state[group],
            [name]: e.value,
          },
        },
        () => this.validate(group, name, this.resetStates),
      );
      return;
    }

    if (name == 'technologyType') {
      if (e.value == 'inne') {
        const valueDict = {
          label: 'Technologia wykonania zbiornika [inne]:',
          editable: true,
        }
        const index = Object.keys(septicTankInfoDict).indexOf('technologyType') + 1;
        septicTankInfoDict = utils.insertKeyAtPosition(septicTankInfoDict, 'otherTechnologyType', valueDict, index)
      } else {
        septicTankInfoDict = utils.deleteKeys(septicTankInfoDict, ['otherTechnologyType']);
      }
    }

    if (name == 'bottomSealantType') {
      if (e.value == 'inne') {
        const valueDict = {
          label: 'Uszczelnienie dna zbiornika [inne]:',
          editable: true,
        }
        const index = Object.keys(septicTankInfoDict).indexOf('bottomSealantType') + 1;
        septicTankInfoDict = utils.insertKeyAtPosition(septicTankInfoDict, 'otherBottomSealantType', valueDict, index)
      } else {
        septicTankInfoDict = utils.deleteKeys(septicTankInfoDict, ['otherBottomSealantType']);
      }
    }

    if (name == 'contractFrequency') {
      if (e.value == 'inna') {
        const valueDict = {
          label: 'Częstotliwość opróżniania zbiornika [inna]:',
          editable: true,
        }
        const index = Object.keys(contractInfoDict).indexOf('contractFrequency') + 1;
        contractInfoDict = utils.insertKeyAtPosition(contractInfoDict, 'otherContractFrequency', valueDict, index)
      } else {
        contractInfoDict = utils.deleteKeys(contractInfoDict, ['otherContractFrequency']);
      }
    }

    if (name == 'treatmentPlantType') {
      if (e.value == 'inny') {
        const valueDict = {
          label: 'Typ przydomowej oczyszczalni [inny]:',
          editable: true,
        }
        const index = Object.keys(treatmentPlantInfoDict).indexOf('treatmentPlantType') + 1;
        treatmentPlantInfoDict = utils.insertKeyAtPosition(treatmentPlantInfoDict, 'otherTreatmentPlantType', valueDict, index)
      } else {
        treatmentPlantInfoDict = utils.deleteKeys(treatmentPlantInfoDict, ['otherTreatmentPlantType']);
      }
    }

    if (name == 'receiverType') {
      if (e.value == 'inny') {
        const valueDict = {
          label: 'Odbiornik ścieków oczyszczonych [inny]:',
          editable: true,
        }
        const index = Object.keys(treatmentPlantInfoDict).indexOf('receiverType') + 1;
        treatmentPlantInfoDict = utils.insertKeyAtPosition(treatmentPlantInfoDict, 'otherReceiverType', valueDict, index)
      } else {
        treatmentPlantInfoDict = utils.deleteKeys(treatmentPlantInfoDict, ['otherReceiverType']);
      }
    }

    if (name == 'treatmentPlantContractFrequency') {
      if (e.value == 'inna') {
        const valueDict = {
          label: 'Częstotliwość opróżniania [inna]:',
          editable: true,
        }
        const index = Object.keys(treatmentPlantContractInfoDict).indexOf('treatmentPlantContractFrequency') + 1;
        treatmentPlantContractInfoDict = utils.insertKeyAtPosition(treatmentPlantContractInfoDict, 'treatmentPlantContractOtherFrequency', valueDict, index)
      } else {
        treatmentPlantContractInfoDict = utils.deleteKeys(treatmentPlantContractInfoDict, ['treatmentPlantContractOtherFrequency']);
      }
    }

    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name, this.updateValidators),
    );
  }

  setAllValuesToNull(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        obj[key] = null;
      }
    }

    return obj;
  }

  resetStates = () => {
    const septicTankInfo = this.setAllValuesToNull(cloneDeep(this.state.septicTankInfo));
    const treatmentPlantInfo = this.setAllValuesToNull(cloneDeep(this.state.treatmentPlantInfo));

    this.setState({ septicTankInfo, treatmentPlantInfo}, this.updateValidators);
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info', 'septicTankInfo', 'treatmentPlantInfo'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }
    if (!hasFieldErrors) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          dzialki: [],
          selectedParcels: [],
          info: this.state.info,
          septicTankInfo: this.state.septicTankInfo,
          treatmentPlantInfo: this.state.treatmentPlantInfo,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
        })
        .then(resp => {
          window.location.href = `${this.nextStep}${resp.jobId}`;
        });
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />

        <DecisionContainer
          title={'1. Informacje'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={InfoTypeDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />

        { this.state.info.sewageNetwork != null ?
          <DecisionContainer
            title={'2. Informacje dodatkowe'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={this.state.info.sewageNetwork ? InfoTypeDict2 : InfoTypeDict3}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          /> : null
        }

        { this.state.info.type == 'zbiornik' ?
          <DecisionContainer
            title={'3. Informacje o zbiorniku'}
            data={this.state.septicTankInfo}
            errors={this.state.errors}
            formDict={septicTankInfoDict}
            onChange={e => this.onChange(e, 'septicTankInfo')}
            onChangeSelect={e => this.onChangeSelect(e, 'septicTankInfo')}
          />
        : null}

        { this.state.info.type == 'zbiornik' && this.state.septicTankInfo.contractSigned ?
          <DecisionContainer
            title={'4. Informacje o umowie'}
            data={this.state.septicTankInfo}
            errors={this.state.errors}
            formDict={contractInfoDict}
            onChange={e => this.onChange(e, 'septicTankInfo')}
            onChangeSelect={e => this.onChangeSelect(e, 'septicTankInfo')}
          />
        : null}

        { this.state.info.type == 'oczyszczalnia' ?
          <DecisionContainer
            title={'3. Informacje o oczyszczalni'}
            data={this.state.treatmentPlantInfo}
            errors={this.state.errors}
            formDict={treatmentPlantInfoDict}
            onChange={e => this.onChange(e, 'treatmentPlantInfo')}
            onChangeSelect={e => this.onChangeSelect(e, 'treatmentPlantInfo')}
          />
        : null}

        { this.state.info.type == 'oczyszczalnia' && this.state.treatmentPlantInfo.treatmentPlantContractSigned ?
          <DecisionContainer
            title={'4. Informacje o umowie'}
            data={this.state.treatmentPlantInfo}
            errors={this.state.errors}
            formDict={treatmentPlantContractInfoDict}
            onChange={e => this.onChange(e, 'treatmentPlantInfo')}
            onChangeSelect={e => this.onChangeSelect(e, 'treatmentPlantInfo')}
          />
        : null}

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.startService()}
            >
              Uruchom
            </button>
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

ZgloszenieOczyszczalni.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(ZgloszenieOczyszczalni),
);



// WEBPACK FOOTER //
// src/routes/eservices/ZgloszenieOczyszczalni.js